import filterConstants from '../constants';

const reportsBudgetMonth = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.reportsBudgetMonth,
  properties: {
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.rangeDate]: '',
  },
});

export default reportsBudgetMonth;
